module.exports = __webpack_public_path__ + "static/media/Рыкова Варвара Владиславовна_Корабли солнечного круга_Свердловская обл.-3.png";